import moment from 'moment'
import APIService from '@/api'

export default class APIReport extends APIService{

    constructor(){
        super('reports')
    }


    async generateContractHtml(contractId) {
        var response = this.AxiosInstance
            .get(this.ApiUrl + "/contracthtmldoc", { params: { contractId: contractId } })
            .catch(error => {
                console.log(error.response)
            })

        return response
    }

    async generateContractsHtml(start, size) {
        var response = this.AxiosInstance
            .get(this.ApiUrl + "/contractshtmldoc", { params: { start: start, size: size } })
            .catch(error => {
                console.log(error.response)
            })

        return response
    }

    async generateContractsWord() {
        await this.AxiosInstance
            .get(this.ApiUrl + "/contractsworddoc", {
                responseType: 'arraybuffer',
                timeout: 300000
            })
          .then((response) => {
            //console.log(response);
            //debugger;
            let blob = new Blob([response.data], { type: response.headers["content-type"] } );
            //let filename = (response.headers['Content-Disposition'] || '').split('filename=')[1];

            //À éviter à cause des popup blocker.
            //let url = window.URL.createObjectURL(blob);
            //window.open(url);

            let link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = "Contrats_" + moment().format("YYYYMMDD_HHmm") + ".docx"
            link.click()

          })
    }

    async generateContractWord(contractId) {
        await this.AxiosInstance
            .get(this.ApiUrl + "/contractworddoc", {
                responseType: 'arraybuffer',
                timeout: 300000,
                params: { contractId: contractId }
            })
            .then((response) => {
                //console.log(response);
                //debugger;
                let blob = new Blob([response.data], { type: response.headers["content-type"] } );
                let link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = "Contrats_" + moment().format("YYYYMMDD_HHmm") + ".docx"
                link.click()
            })
            .catch(error => {
                console.log(error.response)
            })
    }

    async generatePoleToInstallExcel() {
        await this.getExcelReport("poletoinstallexcel", "PoteauxAInstaller")
    }

    async generateCustomerPaidNoPoleExcel() {
        await this.getExcelReport("customerpaidnopoleexcel", "ClientsPayesSansPoteau")
    }

    async generateCustomerSnowRemovalExcel() {
        await this.getExcelReport("customersnowremovalexcel", "ClientsADéneiger")
    }

    async generateCustomerNotRenewExcel() {
        await this.getExcelReport("customernotrenewsexcel", "ClientsNonRenouvelés")
    }

    async generateCustomerIncompletePaymentsExcel() {
        await this.getExcelReport("customerincompletepaymentsexcel", "ClientsNonPayé")
    }

    async generateCustomerBaseExcel() {
        await this.getExcelReport("customerbaseexcel", "ClientsBase")
    }

    async generateCustomerTotalByStreetExcel() {
        await this.getExcelReport("customertotalbystreetexcel", "ClientsTotalParRue")
    }

    async generatePhoneNotesExcel(startDate, endDate) {
        await this.getExcelReport("customerphonenotesexcel", "NotesTéléphoniques", { startDate: startDate,  endDate: endDate})
    }

    async generatePaymentsInteractExcel(startDate, endDate) {
      await this.getExcelReport("paymentsinteractexcel", "PaiementsInteract", { startDate: startDate,  endDate: endDate})
    }

    async generatePaymentsBNCExcel(startDate, endDate) {
      await this.getExcelReport("paymentsbncexcel", "PaiementsBNC", { startDate: startDate,  endDate: endDate})
    }

    async generateBankExcel(id) {
      await this.getExcelReport("bankexcel", "ChequesBanque", { depositID: id })
    }

    async getExcelReport(action, reportName, params) {
        await this.AxiosInstance
            .get(this.ApiUrl + "/" + action, {
                responseType: 'arraybuffer',
                timeout: 300000,
                params: params
            })
          .then((response) => {
            let blob = new Blob([response.data], { type: response.headers["content-type"] } );
            let link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = reportName + "_" + moment().format("YYYYMMDD_HHmm") + ".xlsx"
            link.click()
          })
    }

}



// WEBPACK FOOTER //
// ./src/api/report.js